import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { getFlowRunQueryKey, listFlowRunsQueryKey } from "@/api";

/**
 * Refresh everything that shows how a workflow's runs went once one starts, pauses or ends: its runs list, the run,
 * and every space page (its cards show the latest run, on any space holding it or the owner's personal space).
 */
export function useRefreshRunViews() {
  const queryClient = useQueryClient();
  return useCallback(
    (flowUuid: string, runUuid?: string) => {
      const keys = [listFlowRunsQueryKey({ path: { flow_uuid: flowUuid } }), [{ _id: "getSpaceHub" }]];
      if (runUuid) keys.push(getFlowRunQueryKey({ path: { flow_uuid: flowUuid, run_uuid: runUuid } }));
      return Promise.all(keys.map((queryKey) => queryClient.invalidateQueries({ queryKey })));
    },
    [queryClient],
  );
}
